import { put, all, select } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import projectSelectors from "rdx/modules/projects/selectors";
import messages from "rdx/modules/enterpriseProjects/messages";
import { orgProjectsApi } from "rdx/modules/enterpriseProjects/endpoints";
import { ORG_PROJECTS_TAGS } from "rdx/modules/enterpriseProjects/tags";

function* rescindLeadOffer(action) {
  const { id } = action.payload;

  const { success, data, error } = yield* makeRequest.post(`/project_offers/${id}/rescind`, {});

  if (success && data) {
    const enterpriseProjectDetail = yield select(projectSelectors.getProjectDetails);

    yield all([
      yield put(
        actions.setAlertMessageVisible({
          message: messages.ENTERPRISE_RESCIND_OFFER_SUCCESS,
          severity: "success",
        }),
      ),
      yield put(
        actions.setProjectDetails({
          ...enterpriseProjectDetail,
          providerLead: {
            ...enterpriseProjectDetail.providerLead,
            offer: null,
          },
        }),
      ),
      yield put(orgProjectsApi.util.invalidateTags([ORG_PROJECTS_TAGS.ORG_PRE_SALES_PROJECTS])),
    ]);
  } else if (error) {
    yield put(
      actions.setAlertMessageVisible({
        message: messages.ERROR_SUBMITTING_ENTERPRISE_RESCIND_OFFER,
        severity: "error",
      }),
    );
    return getErrorActions({
      error,
      message: messages.ERROR_SUBMITTING_ENTERPRISE_RESCIND_OFFER,
    });
  }

  return null;
}

export default rescindLeadOffer;
